import { render, staticRenderFns } from "./SelectListAddress.vue?vue&type=template&id=0afc8a34&"
import script from "./SelectListAddress.vue?vue&type=script&lang=js&"
export * from "./SelectListAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports